var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{'small': _vm.small},attrs:{"src":"/assets/images/loader.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }